import { Loader, PlainLayout } from '@/components/shared';
import { Box, Container, Flex, Heading } from '@chakra-ui/react';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { GuestForm } from '../components/GuestForm';
import type { IManageGuestForm } from '../types';

export const GuestFormPage = (): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGuestFormSubmit = (data: IManageGuestForm): void => {
    const { id } = data;

    if (id) {
      navigate(`/details/${id}`);
    }
  };

  return (
    <PlainLayout>
      <Suspense fallback={<Loader />}>
        <Box bg="brand.sand" px={{ base: '15px', md: 0 }} py={{ base: 8, md: 16 }} w="full">
          <Container bg="white" minW="75%" pt="5%" px={{ base: '5%', md: '22%' }} py="5%">
            <Flex alignItems="center" direction="column">
              <Heading fontSize={{ base: 24, md: 38 }} textAlign="center" w="100%">
                {t('GUEST.GUEST_FORM.TITLE')}
              </Heading>
              <GuestForm onSubmit={handleGuestFormSubmit} />
            </Flex>
          </Container>
        </Box>
      </Suspense>
    </PlainLayout>
  );
};
